import styled, { css } from 'styled-components';

export type TitleProps = {
  textTransform?: string;
  textDecoration?: string;
  type?: 'mode1' | 'mode2' | 'mode3' | 'mode4' | 'mode5' | 'mode6' | 'mode7';
  fw?: 'light' | 'medium' | 'bold';
};

const Title = styled.p<TitleProps>`
  letter-spacing: -0.5px;
  color: ${({ theme }) => theme.colors.blackPallet1};
  text-transform: ${(props) => props.textTransform};
  text-decoration: ${(props) => props.textDecoration};

  ${({ fw }) => {
    switch (fw) {
      case 'light':
        return css`
          font-family: Walsheim-Light;
        `;
      case 'medium':
        return css`
          font-family: Walsheim-Medium;
        `;
      case 'bold':
        return css`
          font-family: Walsheim-Bold;
        `;
      default:
        return css`
          font-family: Walsheim-Regular;
        `;
    }
  }}

  ${(props) => {
    switch (props.type) {
      case 'mode1':
        return css`
          font-size: ${props.theme.typography.titles.mode1.fontSize};
          line-height: ${props.theme.typography.titles.mode1.lineHeight};
        `;
      case 'mode2':
        return css`
          font-size: ${props.theme.typography.titles.mode2.fontSize};
          line-height: ${props.theme.typography.titles.mode2.lineHeight};
        `;
      case 'mode3':
        return css`
          font-size: ${props.theme.typography.titles.mode3.fontSize};
          line-height: ${props.theme.typography.titles.mode3.lineHeight};
        `;
      case 'mode4':
        return css`
          font-size: ${props.theme.typography.titles.mode4.fontSize};
          line-height: ${props.theme.typography.titles.mode4.lineHeight};
        `;
      case 'mode5':
        return css`
          font-size: ${props.theme.typography.titles.mode5.fontSize};
          line-height: ${props.theme.typography.titles.mode5.lineHeight};
        `;
      case 'mode6':
        return css`
          font-size: ${props.theme.typography.titles.mode6.fontSize};
          line-height: ${props.theme.typography.titles.mode6.lineHeight};
        `;
      case 'mode7':
        return css`
          font-size: ${props.theme.typography.titles.mode7.fontSize};
          line-height: ${props.theme.typography.titles.mode7.lineHeight};
        `;
      default:
        return css`
          font-size: ${props.theme.typography.titles.default.fontSize};
          line-height: ${props.theme.typography.titles.default.lineHeight};
        `;
    }
  }}
`;

export default Title;
